export class AsciiText {
    static decode(data) {
        const length = data.length;
        const chars = [];
        for (let i = 0; i < length; i++) {
            chars.push(String.fromCharCode(data[i]));
        }
        return chars.join('');
    }
    static encode(str) {
        const length = str.length;
        const data = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
            data[i] = str.charCodeAt(i) & 0x0ff;
        }
        return data;
    }
    static hexlify(data) {
        const length = data.length;
        const hex = [];
        for (let i = 0; i < length; i++) {
            const b = data[i];
            hex.push(b < 16 ? `0${b.toString(16)}` : b.toString(16));
        }
        return hex.join('');
    }
    static unhexlify(str) {
        const length = str.length;
        const length2 = length / 2;
        const data = new Uint8Array(length2);
        for (let i = 0; i < length2; i++) {
            data[i] = (parseInt(str[2 * i], 16) << 4) + parseInt(str[2 * i + 1], 16);
        }
        return data;
    }
}
